/**
 * Helpers for building Surebet view-filter active chip lists.
 */

export const MAX_VISIBLE_GROUP_CHIPS = 3;

/**
 * Build chips for a multi-select group: none / individuals / collapsed summary.
 * @param {Object} options
 * @returns {Array}
 */
export const buildGroupChips = ({
  selected,
  noneId,
  noneType,
  noneLabel,
  itemType,
  idPrefix,
  getItemId,
  getItemLabel,
  summaryId,
  summaryType,
  summaryLabel,
  maxVisible = MAX_VISIBLE_GROUP_CHIPS
}) => {
  if (!Array.isArray(selected)) {
    return [];
  }

  if (selected.length === 0) {
    return [{ id: noneId, type: noneType, label: noneLabel }];
  }

  if (selected.length > maxVisible) {
    return [{
      id: summaryId,
      type: summaryType,
      label: summaryLabel
    }];
  }

  return selected.map((item) => ({
    id: `${idPrefix}${getItemId(item)}`,
    type: itemType,
    item,
    label: getItemLabel(item)
  }));
};

export default {
  MAX_VISIBLE_GROUP_CHIPS,
  buildGroupChips
};
